<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[ { title: { text: $t('chart_legends.distance') }} ]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name),
        tickPlacement: 'between'
      }"
      :colors="['#008FFB', '#775DD0']"
      :fill="{opacity: [1,1]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <v-row
            dense
            align="center"
          >
            <v-col class="text-no-wrap">
              <div class="subtitle-2 grey--text text--grey-100">
                {{ $t('card_title.team_total_dist_vs_hsr') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
              </div>
            </v-col>
          </v-row>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.team_total_dist_vs_hsr') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="players"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'TotalDistHsrChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('UXPCSTD'), type: 'bar', label: this.$t('card_title.total_distance') },
        { key: addAggregation('CALETLDLHSR'), type: 'bar', label: this.$t('chart_legends.distance') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '40%'
        },
        {
          text: this.$t('card_title.total_distance'),
          value: valuePrefix + addAggregation('UXPCSTD'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('chart_legends.distance'),
          value: valuePrefix + addAggregation('CALETLDLHSR'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
